export default __webpack_public_path__ + "static/media/amanida.59040e4f.jpg";